import React from "react";
import { NakiNigunAddAlbumLoaderTemplate } from "themes/administration/naki-nigun/components";

const NakiNigunAddAlbumLoader = (props) => {
    return <NakiNigunAddAlbumLoaderTemplate {...props} />;
};

export default NakiNigunAddAlbumLoader;
